export default {
  area: "三门峡开发区智慧养老",
  objectName: "",
  //url
  // hostUrl : 'http://cuiyun.dexian.ren/',
  hostUrl: 'https://smxzhyl.anluoyun.cn',
  apiHttpsUrl: 'https://smxzhyl.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://smxzhyl.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://smxzhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://smxzhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://smxzhyl.anluoyun.cn/prod-api/So/',
}